<template>
  <div>
    <v-navigation-drawer app v-model="drawer" absolute temporary v-if="isAuthenticated">
      <v-list-item hidden-sm-only pa-1>
        <v-list-item-content>
          <v-list-item-title class="title">
            {{
            getProfileName
            }}
          </v-list-item-title>
          <v-list-item-subtitle v-html="profile ? profile.email : ''"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list v-if="isManager" pt-0 dense nam>
        <v-list-item v-for="item in navitems" :key="item.title" @click.stop>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <router-link :to="item.to">{{ item.title }}</router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list v-else pt-0 dense nav>
        <v-list-item v-for="item in limitedNavitems" :key="item.title" @click.stop>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <router-link :to="item.to">{{ item.title }}</router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed v-if="isAuthenticated && isManager">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Clac Admin</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items
        class="hidden-xs-only"
        v-for="item in navitems"
        :key="item.title"
        @click.stop
      >
        <v-btn text icon :to="item.to" :title="item.title">
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-toolbar fixed v-if="isAuthenticated && !isManager">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Clac Admin</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items
        class="hidden-xs-only"
        v-for="item in limitedNavitems"
        :key="item.title"
        @click.stop
      >
        <v-btn text icon :to="item.to" :title="item.title">
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AppNavigation",
  data() {
    return {
      drawer: null,
      navitems: [
        { title: "Home", icon: "home", to: "/" },
        { title: "Profiles", icon: "people", to: "/profiles" },
        { title: "Users", icon: "queue", to: "/users/qonto" },
        { title: "Orders", icon: "list_alt", to: "/orders" },
        { title: "Invoices", icon: "credit_card", to: "/invoices" },
        { title: "Businesses", icon: "business", to: "/business" },
        { title: "Plans", icon: "style", to: "/plans" },
        { title: "Partners", icon: "store_mall_directory", to: "/partners" },
        { title: "Services", icon: "local_shipping", to: "/services" },
        { title: "Offers", icon: "local_offer", to: "/offers" },
        { title: "Coupons", icon: "receipt", to: "/coupons" },
        { title: "Logs", icon: "date_range", to: "/logs" },
        { title: "Logout", icon: "logout", to: "/logout" }
      ],
      limitedNavitems: [
        { title: "Home", icon: "home", to: "/" },
        { title: "Profiles", icon: "people", to: "/profiles" },
        { title: "Users", icon: "queue", to: "/users/qonto" },
        { title: "Orders", icon: "list_alt", to: "/orders" },
        { title: "Invoices", icon: "credit_card", to: "/invoices" },
        { title: "Partners", icon: "store_mall_directory", to: "/partners" },
        { title: "Services", icon: "local_shipping", to: "/services" },
        { title: "Coupons", icon: "receipt", to: "/coupons" },
        { title: "Logout", icon: "logout", to: "/logout" }
      ]
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "profile"]),
    ...mapGetters(["isManager"]),
    getProfileName() {
      let profileName = [];
      if (this.profile) {
        if (this.profile.first_name) {
          profileName.push(this.profile.first_name);
        }
        if (this.profile.last_name) {
          profileName.push(this.profile.last_name);
        }
      } else {
        profileName.push("");
      }
      return profileName.join(" ");
    }
  },
  methods: {},
  mounted: function() {},
  watch: {}
};
</script>
